export default __webpack_public_path__ + "static/media/kids-learning.fcd258b6.png";